import React from 'react';
import { Typography, Box } from '@mui/material';

const ClinicDetails = () => {
  return (
    <Box mt={4}>
      <Typography variant="body1" color="text.secondary">
        Details tab content goes here...
      </Typography>
    </Box>
  );
};

export default ClinicDetails;
